import { environment } from '../config/environment';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

export function isLocalhost() {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development';
  }

  return LOCAL_HOSTS.has(window.location.hostname);
}

export function getPortalBaseUrl() {
  if (isLocalhost()) {
    return (process.env.REACT_APP_PORTAL_URL || 'http://localhost:3000').replace(/\/$/, '');
  }

  return environment.portalUrl.replace(/\/$/, '');
}

export function getCustomerBaseUrl() {
  if (isLocalhost()) {
    return (process.env.REACT_APP_CUSTOMER_APP_URL || 'http://localhost:3001').replace(/\/$/, '');
  }

  return '';
}

export function getPortalSelectUrl() {
  return `${getPortalBaseUrl()}/velg-kommune`;
}

export function resolveCustomerAppUrl(customer) {
  if (!customer) {
    return getCustomerBaseUrl() || '/';
  }

  if (isLocalhost()) {
    const base = getCustomerBaseUrl();
    return `${base}?k=${encodeURIComponent(customer.id)}`;
  }

  return customer.appUrl;
}

/** Keep local testing on localhost even if a production URL slips through. */
export function rewriteUrlForLocalhost(url) {
  if (!isLocalhost() || !url) {
    return url;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    const host = parsed.hostname;

    if (host === 'app.opencare.no') {
      return `${getPortalBaseUrl()}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    if (host.endsWith('.opencare.no')) {
      return `${getCustomerBaseUrl()}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return url;
  }

  return url;
}

export function redirectTo(url) {
  window.location.replace(rewriteUrlForLocalhost(url));
}

export function navigateTo(url) {
  window.location.href = rewriteUrlForLocalhost(url);
}

export function shouldEnforceCustomerHostname() {
  return !isLocalhost();
}
